import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { nameof } from '@bds/core';
import {
    UntypedFormControl,
    UntypedFormGroup,
    ValidatorFn,
    AbstractControl,
    ValidationErrors,
    Validators,
    FormGroup,
    FormControl,
} from '@angular/forms';
import { ReportParameterModel } from '../../models/report-parameters.model';

@Component({
    selector: 'rt-report-parameters',
    templateUrl: './rt-report-parameters.component.html',
    styleUrls: ['./rt-report-parameters.component.css'],
})
export class RtReportParametersComponent implements OnInit {
    reportForm: UntypedFormGroup;

    @Input() controlNames: string[] = ['Begin Date', 'End Date'];
    @Input() matStyle: 'fill' | 'outline' | 'standard' | 'legacy' = 'fill';
    @Output() getReport: EventEmitter<any> = new EventEmitter();
    @Output() cancelReport: EventEmitter<any> = new EventEmitter();

    constructor() {}

    get dxMatStyle(): string {
        switch (this.matStyle) {
            case 'fill':
                return 'filled';
            case 'outline':
                return 'outlined';
            case 'standard':
                return 'underlined';
            default:
                return 'underlined';
        }
    }

    ngOnInit(): void {
        this.reportForm = this.getFormGroup();
    }

    onDateChanged() {
        this.reportForm.updateValueAndValidity();
    }

    getFormGroup(): FormGroup {
        const formGroup = new FormGroup({});
        formGroup.addControl(
            nameof<ReportParameterModel>('startDate'),
            new FormControl('', [Validators.required]),
        );
        formGroup.addControl(
            nameof<ReportParameterModel>('endDate'),
            new FormControl('', [Validators.required]),
        );
        formGroup.setValidators([dateRangeValidator]);

        formGroup.get('startDate').valueChanges.subscribe(() => {
            formGroup.updateValueAndValidity({ emitEvent: false });
        });
        formGroup.get('endDate').valueChanges.subscribe(() => {
            formGroup.updateValueAndValidity({ emitEvent: false });
        });

        return formGroup;
    }

    onGetReportClick() {
        this.reportForm.get('startDate').updateValueAndValidity();
        this.reportForm.get('endDate').updateValueAndValidity();

        this.reportForm.updateValueAndValidity();

        Object.keys(this.reportForm.controls).forEach((key) => {
            this.reportForm.controls[key].markAsTouched();
        });

        if (this.reportForm.valid) {
            this.getReport.emit({
                startDate: this.reportForm.controls.startDate.value,
                endDate: this.reportForm.controls.endDate.value,
            });
        }
    }

    onCancelClick() {
        this.reportForm.reset();
        this.cancelReport.emit();
    }
}

export const dateRangeValidator: ValidatorFn = (
    formGrp: UntypedFormGroup,
): ValidationErrors | null => {
    const fromCtrl = formGrp.get('startDate');
    const toCtrl = formGrp.get('endDate');

    if (!fromCtrl?.value || !toCtrl?.value) {
        return null;
    }

    const fromDate = new Date(fromCtrl.value);
    const toDate = new Date(toCtrl.value);

    if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
        return null;
    }

    fromDate.setHours(0, 0, 0, 0);
    toDate.setHours(0, 0, 0, 0);

    const rangeCondition = fromDate > toDate;
    return rangeCondition ? { dateRangeInvalid: true } : null;
};
